import { render, staticRenderFns } from "./purchaseReturnAction.vue?vue&type=template&id=5818e16e&scoped=true"
import script from "./purchaseReturnAction.vue?vue&type=script&lang=js"
export * from "./purchaseReturnAction.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnAction.vue?vue&type=style&index=0&id=5818e16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5818e16e",
  null
  
)

export default component.exports